import classNames from 'classnames';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import { SectionTextWithColorProps } from 'eco-design-micro/props/msg/SectionTextProps';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useState } from 'react';
import './index.scss';

export interface EcoBlogItemProps extends SectionTextWithColorProps, ImgVideoProps, EcoTabItemProps {
    /**
     * label 是图片
     */
    labelIsImg?: boolean;
}

interface EcoTabSectionLRProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 列表
     */
    items?: EcoBlogItemProps[];
    /**
     * 样式名
     */
    className?: string;
    /**
     * 切换面板的回调
     */
    onChange?: (item: EcoTabSectionLRProps, index: number) => void;
}

/**
 * 博客列表(标题 + 描述)
 */
const EcoTabSectionLR: React.FC<EcoTabSectionLRProps> = ({ theme = 'white', className, onChange, ...reset }) => {
    const props = reset || {};
    const prefixCls = `eco-tab-section-l-r`;
    const items = props.items || [];
    const defaultItem = items[0] || {};
    const [activeItem, setActiveItem] = useState(defaultItem);
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-label-img`]: activeItem.labelIsImg,
    });
    const itemCompStyle = {
        '--item-titleColor': activeItem.titleColor,
        '--item-descColor': activeItem.descColor,
    } as React.CSSProperties;
    // 切换
    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveItem(items[index]);
        if (onChange) {
            onChange(items[index], index);
        }
    };
    return (
        <div className={classes} style={itemCompStyle}>
            <div className={`${prefixCls}-container eco-content`}>
                <div className={`${prefixCls}-c`}>
                    <div className={`${prefixCls}-img`}>
                        <EcoImgVideo isVideo={activeItem.isVideo} pc={activeItem.pc} pad={activeItem.pad} h5={activeItem.h5} loop={true} />
                    </div>
                    <div className={`${prefixCls}-msg`}>
                        <div className={`${prefixCls}-msg-in`}>
                            <div className={`${prefixCls}-label`}>{activeItem.label}</div>
                            <div className={`${prefixCls}-title`}>{activeItem.title}</div>
                            <div className={`${prefixCls}-desc`}>{activeItem.desc}</div>
                        </div>
                    </div>
                </div>
                <div className={`${prefixCls}-tab`}>
                    <EcoTab onChange={toggleItemHandle} items={items} theme={theme} />
                </div>
            </div>
        </div>
    );
};

export default EcoTabSectionLR;
